module.exports = __webpack_public_path__ + "img/kassa24.ad9ba2d1.png";